var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.939 15.091c.074 1.68-1.281 3.1-3.027 3.171-.129.006-6.398-.007-6.398-.007-1.737.132-3.258-1.116-3.395-2.79-.01-.124-.007-6.85-.007-6.85-.077-1.682 1.276-3.106 3.023-3.18.13-.006 6.391.006 6.391.006 1.746-.13 3.271 1.127 3.406 2.808.01.121.007 6.842.007 6.842Z",
    stroke: "#203040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.942 9.996 3.018-2.47c.748-.612 1.87-.079 1.87.886l-.011 6.737c-.001.965-1.124 1.494-1.87.882l-3.007-2.47",
    stroke: "#203040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgVideo;